/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react';
import { Trans } from 'react-i18next';
import cn from 'classnames';

import { EContentFormats } from 'common/components/LibraryItemCardWidgetOptions';

import styles from './styles.module.scss';

export const FormatSwitcher: React.FunctionComponent<{
  readonly onClickButtons?: React.MouseEventHandler<HTMLButtonElement>;
  readonly type: EContentFormats;
}> = ({ onClickButtons, type }) => {
  return (
    <div className={styles.root}>
      <Trans
        i18nKey="displayAsWebTableOrImage"
        components={[
          <button
            key="0"
            className={cn({
              [styles.buttonActive]: type === EContentFormats.Image,
            })}
            onClick={onClickButtons}
            data-name="web-table"
            type="button"
            disabled={type === EContentFormats.WebTable}
          >
            Web Table
          </button>,
          <button
            key="1"
            className={cn({
              [styles.buttonActive]: type === EContentFormats.WebTable,
            })}
            onClick={onClickButtons}
            data-name="image"
            type="button"
            disabled={type === EContentFormats.Image}
          >
            Image
          </button>,
        ]}
      />
    </div>
  );
};
